var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-list-group-item",
    {
      staticClass: "px-2 py-2",
      attrs: {
        "bg-variant": "light",
        button: _vm.item.children && _vm.item.children.length > 0
      },
      on: {
        click: function($event) {
          $event.stopPropagation()
          _vm.visible = !_vm.visible
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("div", { staticClass: "d-inline-flex align-items-center" }, [
            _vm.item.children && _vm.item.children.length
              ? _c("div", { staticClass: "mx-2" }, [
                  _vm.visible
                    ? _c(
                        "span",
                        { staticClass: "float-right" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "chevron-up", size: "xs" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.visible
                    ? _c(
                        "span",
                        { staticClass: "float-right" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "chevron-right", size: "xs" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v("\n\n      " + _vm._s(_vm.item.name) + "\n    ")
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("b-form-checkbox", {
                staticClass: "ml-1",
                attrs: {
                  indeterminate: _vm.item.indeterminate,
                  disabled:
                    _vm.isCheckboxDisabled(_vm.item.code) || _vm.isDisabled
                },
                on: {
                  change: function($event) {
                    return _vm.handleCheckboxChange(_vm.item)
                  }
                },
                model: {
                  value: _vm.item.checked,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "checked", $$v)
                  },
                  expression: "item.checked"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.item.children && _vm.item.children.length > 0
        ? _c(
            "b-collapse",
            {
              staticClass: "mt-2",
              attrs: { id: "collapse-" + _vm.item.code },
              model: {
                value: _vm.visible,
                callback: function($$v) {
                  _vm.visible = $$v
                },
                expression: "visible"
              }
            },
            [
              _c(
                "b-list-group",
                { staticClass: "perm-group", attrs: { "bg-variant": "light" } },
                _vm._l(_vm.item.children, function(child, index) {
                  return _c("PermissionListItem", {
                    key: index,
                    attrs: {
                      item: child,
                      "tree-data": _vm.treeData,
                      "is-disabled": _vm.isDisabled
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7aa913f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa913f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/PermissionListItem.vue
// module id = null
// module chunks = 